/** Shared dark theme variables for SelfHeal Clerk surfaces. */
const darkSurfaceVariables = {
  colorBackground: '#0c0d10',
  colorForeground: '#e6e7eb',
  colorMutedForeground: '#b8bcc4',
  colorInput: '#13151a',
  colorInputForeground: '#e6e7eb',
  colorBorder: 'rgba(27, 30, 37, 0.7)',
  colorPrimary: '#34d399',
  colorPrimaryForeground: '#08080a',
  borderRadius: '6px',
  fontSize: '13px',
  // Legacy aliases — kept for older Clerk variable names still in use.
  colorInputBackground: '#13151a',
  colorText: '#e6e7eb',
  colorTextSecondary: '#b8bcc4',
  colorNeutral: '#8a909c',
}

/** Default dark appearance for ClerkProvider (modals, org creation, etc.). */
export const clerkProviderAppearance = {
  variables: darkSurfaceVariables,
}

/** Dark SelfHeal surfaces for Clerk organization switcher (sidebar + gate). */
export const workspaceSwitcherAppearance = {
  variables: darkSurfaceVariables,
  elements: {
    organizationSwitcherTrigger: {
      width: '100%',
      minHeight: '2.5rem',
      padding: '0.5rem 0.625rem',
      border: '1px solid #13151a',
      borderRadius: '6px',
      backgroundColor: 'rgba(255, 255, 255, 0.02)',
      justifyContent: 'flex-start',
      overflow: 'visible',
    },
    organizationPreview: {
      gap: '0.5rem',
      overflow: 'visible',
    },
    organizationPreviewTextContainer: {
      overflow: 'visible',
      lineHeight: '1.35',
    },
    organizationPreviewMainIdentifier: {
      lineHeight: '1.35',
      fontWeight: '600',
      overflow: 'visible',
    },
    organizationPreviewSecondaryIdentifier: {
      lineHeight: '1.35',
    },
    organizationSwitcherPopoverCard: {
      border: '1px solid #13151a',
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.45)',
    },
  },
}

/** Dark theme variables for Clerk SignIn page. */
export const signInAppearance = {
  variables: darkSurfaceVariables,
}

/** Create-organization form — explicit input/label contrast on dark surfaces. */
export const createOrganizationAppearance = {
  variables: darkSurfaceVariables,
  elements: {
    card: {
      backgroundColor: '#0c0d10',
      border: '1px solid rgba(27, 30, 37, 0.7)',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
    },
    headerTitle: {
      color: '#e6e7eb',
    },
    headerSubtitle: {
      color: '#b8bcc4',
    },
    formFieldLabel: {
      color: '#e6e7eb',
    },
    formFieldInput: {
      color: '#e6e7eb',
      backgroundColor: '#13151a',
      border: '1px solid rgba(27, 30, 37, 0.7)',
    },
    formButtonPrimary: {
      backgroundColor: '#34d399',
      color: '#08080a',
    },
  },
}

/** Dark theme variables for Clerk UserButton popup. */
export const userButtonAppearance = {
  variables: darkSurfaceVariables,
  elements: {
    userButtonPopoverCard: {
      border: '1px solid rgba(27, 30, 37, 0.7)',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
      backgroundColor: '#0c0d10',
    },
    userButtonPopoverFooter: {
      backgroundColor: '#0c0d10',
      borderTop: '1px solid rgba(27, 30, 37, 0.7)',
    },
    userButtonPopoverActionButtonIcon: {
      color: '#e6e7eb',
    },
    userButtonPopoverActionButton: {
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.04)',
      },
    },
  },
}
